export const ROUTES = {
  ROOT: '/',
  AI_TUTOR: '/ai-tutor',
  AI_TUTOR_CONCEPT_SESSION_GENERATE: '/ai-tutor/concept-session-generate/:sessionId',
  ASSIGNMENTS: '/assignments',
  CLASSES: '/live-classes',
  CLASS_DETAILS: '/live-classes/:id',
  DASHBOARD: '/dashboard',
  LOGIN: '/login',
  PRACTICE_CHAPTER: '/practice/chapters/:chapterId',
  PRACTICE_PROGRESS: '/practice/chapters/:chapterId/progress',
  PRACTICE_LEVEL: '/practice/chapters/:chapterId/levels/:levelScore',
  TESTS: '/tests',
  TEST_QR_UPLOAD: '/tests/:testId/qr-upload',
  SSO: '/sso/:testId',
  REPORTS: '/reports',
  SKILLS: '/skills',
  SPARKY: '/sparky',
  SPARKY_SESSIONS: '/ai-sessions',
  PRACTICE: '/practice',
  LEARNING_ZONE: '/videos',
  VIDEO_PRESENTATION: '/chapter-video',
  SAT_DASHBOARD: '/sat-dashboard',
  SAT_TEST_REPORT: '/sat-dashboard/test-report/:testId',
  DEFAULT: '*',
};
